<sk-subtab-nav
  [tabs]="tabs"
  [subTabUrlSection]="6">
</sk-subtab-nav>
